export const compareItems = [
  {
    id: "live-room-shared-screen",
    title: "直播间同框：头部主播与一线演员，谁在主导话题权",
    category: "直播同框",
    summary:
      "一场看似轻松的带货直播，其实是两种职业身份在同一空间里的位置博弈。主播掌控节奏与转化，演员带来信任与形象溢价，谁主导话题往往取决于当晚的目标是什么。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20studio%20scene%20with%20a%20glowing%20ring%20light%20and%20a%20vintage%20film%20camera%20facing%20each%20other%20on%20a%20dark%20walnut%20table%2C%20drifting%20golden%20haze%2C%20crimson%20and%20amber%20accents%2C%20moody%20cinematic%20lighting%2C%20no%20people%2C%20magazine%20photography%2C%20minimal%20composition&width=1200&height=900&seq=kawei-cmp-01&orientation=landscape",
    leftName: "头部带货主播",
    leftTag: "网红阵营",
    rightName: "一线影视演员",
    rightTag: "明星阵营",
    dimensions: [
      { label: "热度指数", left: 94, right: 82 },
      { label: "话题讨论", left: 88, right: 79 },
      { label: "商业价值", left: 91, right: 86 },
      { label: "专业认可", left: 68, right: 93 },
      { label: "破圈程度", left: 84, right: 96 },
    ],
    verdict:
      "在转化导向的场域里主播占优，在形象与信任导向的场域里演员占优。真正决定话题权归属的，是当晚这场直播究竟冲着销量还是冲着品牌形象。",
    heat: 98650,
    date: "2026-08-28",
    author: "咖位观察局 · 编辑部",
    tags: ["直播同框", "话题权", "转化率"],
  },
  {
    id: "same-brand-different-level",
    title: "同一品牌换了合作对象，头衔差异藏着什么",
    category: "品牌代言",
    summary:
      "从全球代言人到品牌挚友，头衔的层级往往比价格更能说明位置关系。当同一品牌在不同市场启用不同量级的合作对象，背后是一整套人群分层策略。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20still%20life%20of%20two%20luxury%20product%20packages%20placed%20at%20different%20heights%20on%20a%20warm%20beige%20pedestal%2C%20soft%20golden%20spotlight%2C%20deep%20red%20velvet%20backdrop%20blurred%20behind%2C%20no%20people%2C%20refined%20fashion%20magazine%20aesthetic%2C%20clean%20minimal%20composition&width=1200&height=900&seq=kawei-cmp-02&orientation=landscape",
    leftName: "品牌全球代言",
    leftTag: "传统明星路线",
    rightName: "品牌挚友合作",
    rightTag: "网红合作路线",
    dimensions: [
      { label: "热度指数", left: 78, right: 89 },
      { label: "话题讨论", left: 74, right: 86 },
      { label: "商业价值", left: 92, right: 83 },
      { label: "专业认可", left: 90, right: 66 },
      { label: "破圈程度", left: 88, right: 81 },
    ],
    verdict:
      "头衔层级与带货效率是两条平行线。品牌往往用高头衔稳住形象，用轻量合作测试转化，两者并不矛盾，只是承担的任务不同。",
    heat: 87210,
    date: "2026-08-21",
    author: "咖位观察局 · 商业组",
    tags: ["品牌代言", "头衔体系", "人群分层"],
  },
  {
    id: "variety-screen-time",
    title: "综艺同台，镜头时长能说明多少问题",
    category: "综艺同台",
    summary:
      "把一期节目里每个人的有效镜头秒数统计出来，会得到一张相当直观的位置图。但镜头时长并非唯一答案，它同时受叙事结构、嘉宾功能与当期主题影响。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Abstract%20television%20studio%20set%20with%20several%20empty%20director%20chairs%20arranged%20in%20a%20row%20under%20warm%20amber%20spotlights%2C%20deep%20burgundy%20floor%2C%20soft%20cinematic%20haze%2C%20no%20people%2C%20editorial%20broadcast%20magazine%20aesthetic%2C%20symmetrical%20composition&width=1200&height=900&seq=kawei-cmp-03&orientation=landscape",
    leftName: "综艺常驻嘉宾",
    leftTag: "明星阵营",
    rightName: "飞行网红嘉宾",
    rightTag: "网红阵营",
    dimensions: [
      { label: "镜头时长", left: 86, right: 61 },
      { label: "话题讨论", left: 71, right: 88 },
      { label: "商业价值", left: 84, right: 79 },
      { label: "专业认可", left: 88, right: 62 },
      { label: "破圈程度", left: 82, right: 87 },
    ],
    verdict:
      "常驻嘉宾赢在结构位，飞行嘉宾赢在话题爆点。前者是节目的骨架，后者是节目的引信，镜头多寡不等于价值高低。",
    heat: 76430,
    date: "2026-08-14",
    author: "咖位观察局 · 内容组",
    tags: ["综艺同台", "镜头时长", "位置学"],
  },
  {
    id: "red-carpet-order",
    title: "红毯顺序与压轴，位置学里的隐藏规则",
    category: "时尚红毯",
    summary:
      "出场顺序、合影站位、媒体区的停留时长，共同构成一套不成文的红毯位置学。它既反映行业地位，也受活动主题与品牌方意愿的拉扯。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Cinematic%20empty%20red%20carpet%20entrance%20with%20warm%20golden%20spotlights%20crossing%20in%20the%20air%2C%20deep%20crimson%20carpet%20texture%2C%20soft%20camera%20flash%20bokeh%20floating%2C%20no%20people%2C%20luxury%20fashion%20magazine%20photography%2C%20dramatic%20negative%20space&width=1200&height=900&seq=kawei-cmp-04&orientation=landscape",
    leftName: "压轴出场",
    leftTag: "高位置",
    rightName: "开场出场",
    rightTag: "功能位",
    dimensions: [
      { label: "行业地位", left: 94, right: 71 },
      { label: "话题讨论", left: 83, right: 66 },
      { label: "商业价值", left: 90, right: 74 },
      { label: "专业认可", left: 87, right: 79 },
      { label: "破圈程度", left: 89, right: 68 },
    ],
    verdict:
      "压轴往往意味着最高位置，但开场也可能承担「热场」的战略功能。读位置不要只看单一维度，要结合活动主题整体判断。",
    heat: 65180,
    date: "2026-08-05",
    author: "咖位观察局 · 时尚组",
    tags: ["时尚红毯", "出场顺序", "位置学"],
  },
  {
    id: "casting-list-debate",
    title: "选角名单流出后，为什么讨论总跑偏",
    category: "影视选角",
    summary:
      "当流量背景的艺人进入正剧视野，舆论的第一反应常常不是演技，而是预期管理。选角争议的本质，其实是两套评价标准在同一个名字上的碰撞。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Dramatic%20empty%20film%20set%20with%20a%20clapperboard%20and%20director%20monitor%20under%20warm%20amber%20studio%20light%2C%20deep%20charcoal%20background%20with%20soft%20crimson%20glow%2C%20no%20people%2C%20cinematic%20editorial%20photography%2C%20moody%20atmosphere&width=1200&height=900&seq=kawei-cmp-05&orientation=landscape",
    leftName: "正剧班底演员",
    leftTag: "专业路线",
    rightName: "流量背景艺人",
    rightTag: "热度路线",
    dimensions: [
      { label: "专业认可", left: 93, right: 58 },
      { label: "热度指数", left: 69, right: 92 },
      { label: "话题讨论", left: 65, right: 95 },
      { label: "商业价值", left: 80, right: 88 },
      { label: "破圈程度", left: 84, right: 90 },
    ],
    verdict:
      "专业与热度不是零和关系，但确实需要不同的评判周期。用演技标准衡量热度型艺人，或用人气标准衡量专业型演员，都会得出失真的结论。",
    heat: 58720,
    date: "2026-07-29",
    author: "咖位观察局 · 影视组",
    tags: ["影视选角", "预期管理", "评价体系"],
  },
  {
    id: "heat-after-tide",
    title: "热度退潮之后，谁还在稳定营业",
    category: "流量观察",
    summary:
      "短期爆红靠的是单点事件，长期站位靠的是持续经营。当我们把两年的时间轴拉出来，会发现真正拉开差距的是内容节奏与基本盘质量。",
    coverImage:
      "https://readdy.ai/api/search-image?query=Abstract%20calm%20sea%20surface%20after%20a%20tide%20recedes%2C%20warm%20amber%20sunset%20reflection%20on%20gentle%20water%20ripples%2C%20soft%20crimson%20sky%20gradient%2C%20minimal%20editorial%20landscape%20photography%2C%20serene%20and%20refined%20mood&width=1200&height=900&seq=kawei-cmp-06&orientation=landscape",
    leftName: "持续经营型",
    leftTag: "稳定基本盘",
    rightName: "单点爆红型",
    rightTag: "波动较大",
    dimensions: [
      { label: "热度稳定性", left: 89, right: 52 },
      { label: "话题讨论", left: 76, right: 87 },
      { label: "商业价值", left: 88, right: 71 },
      { label: "专业认可", left: 82, right: 64 },
      { label: "破圈程度", left: 81, right: 78 },
    ],
    verdict:
      "爆红是一次机会，稳定是一种能力。热度退潮后还能保持基本盘的，往往是那些把内容节奏当成长期工程来经营的人。",
    heat: 46890,
    date: "2026-07-18",
    author: "咖位观察局 · 数据组",
    tags: ["流量观察", "基本盘", "长期经营"],
  },
];